import React from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import { Link } from 'gatsby';

const SubNavNavigation = ({ data, toggleIsMobileNavOpen }) => {
  return (
    <ul>
      {data?.navigation?.map((navItem, index) => {
        const { slug, icon, title } = navItem;

        return (
          <li className="toolbox-sticky-subnav--item" key={`sub-nav-navigation-${index}`}>
            <Link to={slug} onClick={() => toggleIsMobileNavOpen(false)}>
              {icon && (
                <div className="toolbox-sticky-subnav--item-icon">
                  <WebsiteImage src={icon.src} alt={icon.alt} style={{ maxHeight: '24px' }} />
                </div>
              )}
              <p>{title}</p>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default SubNavNavigation;
